import React from "react";

import Tooltip from "@busbud/design-system-components/dist/Tooltip/Tooltip";
import { IconInfoCircle } from "@busbud/horizon";

import type { LineItemProps } from "@app/components/trip-fare-summary/line-item";
import { LineItem } from "@app/components/trip-fare-summary/line-item";
import { useAppContext } from "@app/helpers/hooks";

import type { Whitelabel } from "@partners/partner.type";

export interface TaxBreakdown {
  national?: number;
  provincial?: number;
}

export interface TaxesLinesProps extends Omit<LineItemProps, "label"> {
  breakdown?: TaxBreakdown;
  whitelabel?: Whitelabel;
}

export const TaxesLines: React.FC<TaxesLinesProps> = ({
  amount,
  breakdown,
  currency_code,
  is_loading
}) => {
  const { translator } = useAppContext();

  if (!amount) {
    return null;
  }

  const has_breakdown = breakdown?.national || breakdown?.provincial;

  if (has_breakdown) {
    return (
      <>
        {!!breakdown.national && (
          <LineItem
            amount={breakdown.national}
            currency_code={currency_code}
            data_testid="taxes_national_line"
            is_loading={is_loading}
            label={translator.t("!checkout.priceinfo.taxes.national")}
          />
        )}
        {!!breakdown.provincial && (
          <LineItem
            amount={breakdown.provincial}
            currency_code={currency_code}
            data_testid="taxes_provincial_line"
            is_loading={is_loading}
            label={translator.t("!checkout.priceinfo.taxes.provincial")}
          />
        )}
      </>
    );
  }

  return (
    <LineItem
      amount={amount}
      currency_code={currency_code}
      data_testid="taxes_line"
      is_loading={is_loading}
      label={translator.t("!checkout.summary.fees-taxes.taxes")}
      tooltip={
        <Tooltip
          arrow
          data-testid="taxes_tooltip"
          placement="top"
          title={translator.t("!checkout.priceinfo.taxes.tooltips")}
        >
          <span>
            <IconInfoCircle size="sm" className="text-color-tertiary" />
          </span>
        </Tooltip>
      }
    />
  );
};
